import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  cancelBraintreeSubscription,
  fetch as fetchSubscriptions,
} from 'actions/subscription';

class Subscriptions extends Component {
  cancelBraintreeSubscription = async () => {
    const { dispatch } = this.props;
    // Cancel the subscription

    if(!window.confirm('Are you sure?')){
      return;
    }

    await dispatch(cancelBraintreeSubscription());
    // Fetch the up-to-date subscription info (so that Redux gets populated properly)
    await dispatch(fetchSubscriptions());
  }

  renderSubs = () => {
    const {
      subscriptions,
      isCancelling,
    } = this.props;
    if (subscriptions.hasBraintreeSubscription) {
      return (
        <div>
          <p>You have a web subscription! You can cancel your subscription any time on this page.</p>
          <button
            className="button button--primary"
            onClick={this.cancelBraintreeSubscription}
          >
            {isCancelling ? 'cancelling...' : 'Cancel'}
          </button>
        </div>
      );
    }
    if (subscriptions.hasAppleSubscription) {
      return (
        <div>
          <p>You have an Apple subscription! You can cancel your subscription any time on this page.</p>
          <button className="button button--primary">Cancel</button>
        </div>
      );
    }
    if (subscriptions.hasAndroidSubscription) {
      return (
        <div>
          <p>You have an Android subscription! You can cancel your subscription any time on this page.</p>
          <button className="button button--primary">Cancel</button>
        </div>
      );
    }
    return <p>You have no subscriptions.</p>;
  }


  render = () => (
    <div>
      <h2 className="heading heading--2">Subscriptions</h2>
      {this.renderSubs()}
    </div>
  )
}

const mapStateToProps = ({
  settings: { subscriptions },
  subscription: { isCancelling },
}) => ({ isCancelling, subscriptions });


export default connect(mapStateToProps)(Subscriptions);